// https://vuex.vuejs.org/en/state.html

export default {
  
    token: localStorage.getItem('access_token') || 0//null
  
}
